import { trackFbqEvent } from "./fbqEventFactory";
import { trackersFactory } from "./trackersFactory";

const trackers = trackersFactory("membership-payment-page");

const changePlanLink = (): void =>
  trackers({ action: "change-membership-plan-link" });

const notConvincedLink = (): void =>
  trackers({ action: "not-convinced-refundable-link" });

const submitPlus = (): void => {
  trackers({ action: "submit-plus-membership-payment-cta" });
  trackFbqEvent("AddPaymentInfo", { content_ids: ["plus"] });
};

const submitPremium = (): void => {
  trackers({ action: "submit-premium-membership-payment-cta" });
  trackFbqEvent("AddPaymentInfo", {
    content_ids: ["premium"],
  });
};

export const trackMembershipPayment = {
  changePlanLink,
  notConvincedLink,
  submitPlus,
  submitPremium,
};
